import { render, staticRenderFns } from "./post-list.vue?vue&type=template&id=5112809c&scoped=true&"
import script from "./post-list.vue?vue&type=script&lang=js&"
export * from "./post-list.vue?vue&type=script&lang=js&"
import style0 from "./post-list.vue?vue&type=style&index=0&id=5112809c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5112809c",
  null
  
)

component.options.__file = "src/demo/packageEditor/post-list.vue"
export default component.exports